var tipos_veiculo;
var params;
var query;
var tipo_veiculo;
var marca;
var modelo;
var ano;
var preco_min;
var preco_max;
var $;

// Código igual tanto para busca da tabela JC quanto para exibição de resultados da tabela JC
function init(jQuery) {
  $ = jQuery;
  reset_field("#modelo", '<option value="">Modelo</option>', true);
  reset_field("#ano", '<option value="">Ano</option>', true);

  tipos_veiculo = ['carro', 'moto', 'caminhao'];
  params = {};
  query = window.location.search.replace('?', '').split('&');

  // Identifica a URL atual
  for (var i = 0; query.length > i; i++) {
    var param = query[i].substring(0, query[i].indexOf("="));
    var value = query[i].substring(query[i].indexOf("=") + 1, query[i].length);
    params[param] = decodeURIComponent(value.replace(/\+/g, " "));
  }

  // Pega parâmetros da URL e associa às variáveis correspondentes
  tipo_veiculo = (params.tipo_veiculo && tipos_veiculo.indexOf(params.tipo_veiculo) >= 0) ? params.tipo_veiculo : $('.tipo_veiculo').children('input').val();
  marca = params.marca ? params.marca : $("#marca").val();
  modelo = params.modelo ? params.modelo : $("#modelo").val();
  ano = params.ano ? params.ano : $("#ano").val();
  preco_min = params.preco_min ? params.preco_min : $("#preco_min").val();
  preco_max = params.preco_max ? params.preco_max : $("#preco_max").val();

  // Busca marcas de veículos para tipo de veículo
  if (tipo_veiculo.length) {
    $('.tipo_veiculo').children('input[value=' + tipo_veiculo + ']').parent().addClass('active');
    $('.tipo_veiculo').children('input[value=' + tipo_veiculo + ']').prop('checked', true);
    $('#preco_min').val(preco_min);
    $('#preco_max').val(preco_max);
    get_opcoes_marca(tipo_veiculo);
  }
}

// Reseta o campo e define seu novo conteúdo
function reset_field(target, content, disable) {
  $(target).attr('disabled', disable);
  $(target).find("option").remove();
  $(target).append(content);
}

// Opções de Marca
function get_opcoes_marca(tipo_veiculo) {
  $.get("/wp-content/themes/estadao/tabela-jc/tabela-jc.php?tipo_veiculo=" + encodeURIComponent(tipo_veiculo) + "&tipo=marca", function(opcoes_marca) {
    reset_field("#marca", opcoes_marca, false);

    // Caso tenha marca selecionada ou exista apenas uma marca
    if ((marca.length && opcoes_marca.indexOf(marca) >= 0) || $('#marca option').size() === 1) {
      if (marca) {
        $("#marca").val(marca);
      } else {
        marca = $("#marca").val();
      }

      get_opcoes_modelo(tipo_veiculo, marca);
    }
  });
}

// Opções de Modelo
function get_opcoes_modelo(tipo_veiculo, marca) {
  $.get("/wp-content/themes/estadao/tabela-jc/tabela-jc.php?tipo_veiculo=" + encodeURIComponent(tipo_veiculo) + "&tipo=modelo&marca=" + encodeURIComponent(marca), function(opcoes_modelo) {
    reset_field("#modelo", opcoes_modelo, false);

    // Caso tenha modelo selecionado ou exista apenas um modelo
    if ((modelo.length && opcoes_modelo.indexOf(modelo) >= 0) || $('#modelo option').size() === 1) {
      if (modelo) {
        $("#modelo").val(modelo);
      } else {
        modelo = $("#modelo").val();
      }

      get_opcoes_ano(tipo_veiculo, marca, modelo);
    }
  });
}

// Opções de Ano/Modelo
function get_opcoes_ano(tipo_veiculo, marca, modelo) {
  $.get("/wp-content/themes/estadao/tabela-jc/tabela-jc.php?tipo_veiculo=" + encodeURIComponent(tipo_veiculo) + "&tipo=ano&marca=" + encodeURIComponent(marca) + "&modelo=" + encodeURIComponent(modelo), function(opcoes_ano) {
    reset_field("#ano", opcoes_ano, false);

    // Caso tenha ano selecionado ou exista apenas um ano para modelo
    if ((ano.length && opcoes_ano.indexOf(ano) >= 0) || $('#ano option').size() === 1) {
      if (ano) {
        $("#ano").val(ano);
      } else {
        ano = $("#ano").val();
      }
    }
  });
}
